import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, onMounted, watch } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useLayoutField } from '@/composables/useLayoutField';
import { useHydratedHeaders } from '@/composables/useHydratedHeaders';
import Toolbar from '@/components/layout/Toolbar.vue';
import Pagination from '@/components/layout/Pagination.vue';
import { configRegistry } from '@/lib/configRegistry';
import { useDialogsStore } from '@/store/dialogs';
import { useRoute } from 'vue-router';

// === PROPS ===

const __default__ = {};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ViewsContainer',
  props: {
    moduleName: {},
    listViewComponent: {},
    calendarViewComponent: {},
    kanbanViewComponent: {},
    gridViewComponent: {},
    cardViewComponent: {},
    filterComponent: {},
    data: {},
    config: {},
    onCreate: { type: Function },
    exportCsv: { type: Function },
    onUpdate: { type: Function },
    onRecordUpdate: { type: Function },
    onDelete: { type: Function },
    show_toolbar: { type: Boolean },
    show_pagination: { type: Boolean },
    title: {},
    rowActionHandlers: {},
    client: {},
    clientId: {},
    product_id: {},
    medium: {},
    selectable: { type: Boolean },
    selectedItems: {},
    tabs: {},
    tabFilterKey: {},
    showTabs: { type: Boolean },
    showTotalsToggle: { type: Boolean },
    totalsVisible: { type: Boolean }
  },
  emits: ["toggle-totals", "update:selectedItems"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const preferencesStore = usePreferencesStore();
const statusField = ref<string>('');

// === VISTAS DISPONIBLES ===
const currentViewComponent = computed(() => {
  switch (useLayoutField(props.moduleName, 'currentView').value) {
    case 'table':
      return props.listViewComponent;
    case 'grid':
      return props.gridViewComponent;
    case 'card':
      return props.cardViewComponent;
    case 'calendar':
      return props.calendarViewComponent;
    case 'kanban':
      return props.kanbanViewComponent;
    default:
      return props.listViewComponent;
  }
});

const availableViews = computed(() => {
  const views = [];
  if (props.listViewComponent) views.push('table');
  if (props.gridViewComponent) views.push('grid');
  if (props.cardViewComponent) views.push('card');
  if (props.calendarViewComponent) views.push('calendar');
  if (props.kanbanViewComponent) views.push('kanban');
  return views;
});


// === HEADERS POR MÓDULO (no más contaminación)
const headers = useHydratedHeaders(props.moduleName);

// === HEADERS ORDENABLES POR MÓDULO
const sortableHeaders = computed(() =>
  preferencesStore.getAllHeadersByModule(props.moduleName).filter((h) => h.sortable)
);

// === ABRIR DETALLE VÍA DIALOGS STORE GLOBAL ===
const dialogsStore = useDialogsStore();

const openDetailDialog = async (item: any, module_name?: string) => {
  const id = item?.id ?? item;
  let moduleName = module_name || props.moduleName as string;

  // Busca el componente DETAIL dinámico de ese módulo
  const loader = configRegistry[moduleName];
  let component: any;
  if (loader) {
    const mod = await loader();
    component = mod?.DETAIL?.component;
  } else {
    console.warn(`[${moduleName}] No se encontró DETAIL.component en configRegistry`);
    return;
  }

  dialogsStore.open(
    moduleName,
    id,
    {
      id, // para el prop id
      client: props.client,
      clientId: props.clientId,
      onUpdate: props.onUpdate,
      rowActionHandlers: props.rowActionHandlers,
      // agrega aquí cualquier prop extra que tu detalle necesite
    }
  );
};

const route = useRoute();
function openDialogIfIdPresent() {
  const id = route.params.id;
  const module = route.meta.moduleName || route.name; // O ajusta esto a tus necesidades
  if (id && module) {
    dialogsStore.open(
      module as string,
      Number(id),
      {
        id: Number(id),
        client: props.client,
        clientId: props.clientId,
        onUpdate: props.onUpdate,
        rowActionHandlers: props.rowActionHandlers,
      }
    );
  }
}

onMounted(async () => {
  const loader = configRegistry[props.moduleName];
  if (loader) {
    const mod = await loader();
    statusField.value = mod?.KANBAN?.statusField ?? 'status'; // fallback genérico
  }
});

onMounted(openDialogIfIdPresent);
watch(() => route.fullPath, openDialogIfIdPresent);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.show_toolbar)
      ? (_openBlock(), _createBlock(Toolbar, {
          moduleName: _ctx.moduleName,
          sortableHeaders: sortableHeaders.value,
          config: _ctx.config,
          onCreate: _ctx.onCreate,
          exportCsv: _ctx.exportCsv,
          title: _ctx.title,
          availableViews: availableViews.value,
          key: _ctx.moduleName,
          client: _ctx.client,
          clientId: _ctx.clientId,
          product_id: _ctx.product_id,
          medium: _ctx.medium,
          tabs: _ctx.tabs,
          tabFilterKey: _ctx.tabFilterKey,
          showTabs: _ctx.showTabs,
          showTotalsToggle: _ctx.showTotalsToggle,
          totalsVisible: _ctx.totalsVisible,
          onToggleTotals: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-totals')))
        }, {
          "before-create": _withCtx(() => [
            _renderSlot(_ctx.$slots, "before-create")
          ]),
          _: 3
        }, 8, ["moduleName", "sortableHeaders", "config", "onCreate", "exportCsv", "title", "availableViews", "client", "clientId", "product_id", "medium", "tabs", "tabFilterKey", "showTabs", "showTotalsToggle", "totalsVisible"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(currentViewComponent.value), {
      moduleName: _ctx.moduleName,
      headers: _unref(headers),
      data: _ctx.data,
      config: _ctx.config,
      onUpdate: _ctx.onUpdate,
      onRecordUpdate: _ctx.onRecordUpdate,
      onDelete: _ctx.onDelete,
      onViewItem: openDetailDialog,
      onEditItem: _ctx.openEditDialog,
      title: _ctx.title,
      statusField: statusField.value,
      rowActionHandlers: _ctx.rowActionHandlers,
      client: _ctx.client,
      clientId: _ctx.clientId,
      key: _ctx.moduleName,
      product_id: _ctx.product_id,
      selectable: _ctx.selectable,
      selectedItems: _ctx.selectedItems,
      "onUpdate:selectedItems": _cache[1] || (_cache[1] = ($event: any) => (emit('update:selectedItems', $event)))
    }, null, 40, ["moduleName", "headers", "data", "config", "onUpdate", "onRecordUpdate", "onDelete", "onEditItem", "title", "statusField", "rowActionHandlers", "client", "clientId", "product_id", "selectable", "selectedItems"])),
    (_ctx.show_pagination)
      ? (_openBlock(), _createBlock(Pagination, {
          key: 1,
          moduleName: _ctx.moduleName,
          title: _ctx.title
        }, null, 8, ["moduleName", "title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})